import { FeatureSection, HowWeWork, OtherServices, StackUsed, WebBuilderFeature } from "@/components/features/websites";
import Footer from "../../components/common/layout/Footer";
import { WebsitesHero } from "@/components/features/websites";
import AnimatedSection from "../../components/common/animations/AnimatedSection";
import ParallaxSection from "../../components/common/animations/ParallaxSection";
import Floating3D from "../../components/common/animations/Floating3D";
import WebsitePlans from "@/components/features/websites/WebsitePlans/WebsitePlans";
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SEO from "@/components/common/seo/seo";

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
}

export default function Websites() {

    useEffect(() => {
        // Animate sections on scroll
        const sections = document.querySelectorAll('.animate-on-scroll');

        sections.forEach((section, index) => {
            gsap.fromTo(section,
                {
                    opacity: 0,
                    y: 100,
                    rotationX: -15,
                    scale: 0.9
                },
                {
                    opacity: 1,
                    y: 0,
                    rotationX: 0,
                    scale: 1,
                    duration: 1,
                    delay: index * 0.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: section,
                        start: "top 85%",
                        toggleActions: "play none none none"
                    }
                }
            );
        });

        // Parallax effect for background elements
        gsap.utils.toArray('.parallax-bg').forEach((element: any) => {
            gsap.to(element, {
                y: () => -ScrollTrigger.maxScroll(window) * 0.5,
                ease: "none",
                scrollTrigger: {
                    trigger: element,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            });
        });

        return () => {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, []);

    return (
        <>
            <SEO
                title="Web Development - SAN micron"
                description="Highly functional and visually appealing website designed to meet your needs."
            />
            <div className="relative overflow-hidden">
                <ParallaxSection speed={0.2}>
                    <Floating3D intensity={10}>
                        <WebsitesHero />
                    </Floating3D>
                </ParallaxSection>
            
                <AnimatedSection delay={0.1} direction="up">
                    <div className="animate-on-scroll">
                        <OtherServices />
                    </div>
                </AnimatedSection>

                <ParallaxSection speed={0.3} direction="down">
                    <AnimatedSection delay={0.2} direction="left">
                        <div className="animate-on-scroll">
                            <WebBuilderFeature />
                        </div>
                    </AnimatedSection>
                </ParallaxSection>

                <AnimatedSection delay={0.3} direction="right">
                    <div className="animate-on-scroll">
                        <Floating3D intensity={15}>
                            <HowWeWork />
                        </Floating3D>
                    </div>
                </AnimatedSection>

                <ParallaxSection speed={0.25}>
                    <AnimatedSection delay={0.4} direction="up">
                        <div className="animate-on-scroll">
                            <FeatureSection />
                        </div>
                    </AnimatedSection>
                </ParallaxSection>

                <AnimatedSection delay={0.5} direction="left">
                    <div className="animate-on-scroll lg:mt-8">
                        <WebsitePlans />
                    </div>
                </AnimatedSection>

                <AnimatedSection delay={0.7} direction="up">
                    <div className="animate-on-scroll">
                        <StackUsed />
                    </div>
                </AnimatedSection>

                <ParallaxSection speed={0.2} direction="up">
                    <AnimatedSection delay={0.6} direction="right">
                        <div className="animate-on-scroll">
                            {/* <Floating3D intensity={12}> */}
                                {/* <WebsitePlans /> */}
                            {/* </Floating3D> */}
                        </div>
                    </AnimatedSection>
                </ParallaxSection>

                <ParallaxSection speed={0.15}>
                    <AnimatedSection delay={0.8}>
                        <div className="abstract-bg animate-on-scroll">
                            {/* <FAQ /> */}
                        </div>
                    </AnimatedSection>
                </ParallaxSection>

                <AnimatedSection delay={0.9}>
                    <Footer />
                </AnimatedSection>
            </div>
        </>
    );
}